import gql from 'graphql-tag'

export const GET_TOPICS_BY_USER_EMAIL = gql`
    query getUserTopicsByUserEmail (
        $fullname: String
        $email: String!
    ) {
        getUserTopicsByUserEmail (
            fullname: $fullname
            email: $email
        ) {
            id
            uid
            topic_uid
            user_uid
            date_attended
            created_at
            user {
                id
                uid
                username
                email
                role_uid
                role {
                    id
                    uid
                    name
                }
                profile {
                    id
                    uid
                    user_uid
                    fullname
                    firstname
                    middlename
                    lastname
                }
                fb_profile_url
                is_activated
                activated_at
            }
            topic {
                id
                uid
                name
            }
        }
    }
`